<new-flowbanner [showPromo]="true"></new-flowbanner>
<div class="pb-5 pb-lg-5 feedback-container">
    <div class="row justify-content-center me-0">
        <div class="col-12 col-md-8 col-lg-6 d-flex flex-column align-items-center text-center">
            <div class="feedback-image-wrapper">
                <img class="feedback-image" src="./assets/img/no-pasa-sarlaft.png" width="500" height="320"
                    alt="Ilustración de no pasa SARLAFT." loading="lazy" />
            </div>

            <h2 class="feedback-title">Lo sentimos :(</h2>
            <p class="feedback-subtitle">
                Luego de realizar algunas validaciones, lamentamos decirte que no podemos ofrecerte el Seguro de Arriendo Digital de SURA, pues no cumples con nuestras políticas internas.
            </p>

            <button (click)="redirect()" type="button"
                class="btn btn-primary btn-lg rounded-pill sura-feedback-btn mt-lg-0 mt-3 mb-5">
                Volver al inicio
            </button>
        </div>
    </div>
</div>

<app-footer-app></app-footer-app>
